'use strict';

import mergeOpts from './merge-opts';
import bezier from 'bezier-easing';

export default function SmoothenChange(callback, o) {

    o = mergeOpts({
        start: 0,
        duration: 300,
        min: 0.01,
        ease: bezier(.7, 0, .3, 1),
        easeEnd: bezier(0, 0, .3, 1),
    }, o);

    let animating = false;
    let start = typeof o.start === 'object' ? o.start : [o.start];
    let end = start;
    let time = 0;
    let progress = 0;
    let oldTime = null;
    let current = start;
    let ease = o.ease;

    function run() {

        start = current;
        end = [];
        
        for (let arg of arguments) {
            if (typeof arg === 'object') {
                o = mergeOpts(o, arg);
            }
            else {
                end.push(arg);
            }
        }
        
        for (let i = start.length; i < end.length; ++i) {
            start.push(o.start);
        }
        
        time = 0;
        if (animating) {
            ease = o.easeEnd;
            return;
        }
        ease = o.ease;
        animating = true;
        animate();
    }

    function animate() {
        requestAnimationFrame(function (t) {
            const delta = oldTime ? (t - oldTime) : 0;
            oldTime = t;
            time += delta;
            progress = Math.max(0, Math.min(1, time / o.duration));
            
            for (let i = 0; i < end.length; ++i) {
                current[i] = start[i] + (end[i] - start[i]) * ease(progress);
            }
            callback.apply(this, current);

            if (progress < 1) {
                animate();
            } else {
                animating = false;
                oldTime = null;
                time = 0;
            }
        });
    }

    return {
        run: run,
    };
}